export default "__VITE_ASSET__D5Pyir6___"